import { PageHeader } from '@/components/ui/PageHeader'
import { useMemo } from 'react'
import { PlatformBreadcrumbs } from './PlatformBreadcrumbs'
import { RedisMenu } from './RedisMenu'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { DataTable } from '@/components/ui/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Button } from '@/components/shadcn/button'
import { PlatformAgentToolsFilters } from './PlatformAgentToolsTable/PlatformAgentToolsFilters'
import { toolColumns } from './PlatformAgentToolsTable/platformAgentToolsTableColumns'
import { getAgentToolsModuleFilterOptions } from './PlatformAgentToolsTable/platformAgentToolsTableUtils'
import { ToolForm } from './Forms/ToolForm'

export function PlatformAgentToolsPage() {
  return (
    <>
      <PageHeader className="pr-3" title={<PlatformBreadcrumbs title="Agent Tools" />}>
        <RedisMenu />
      </PageHeader>
      <PlatformAgentToolsPageContent />
    </>
  )
}

function PlatformAgentToolsPageContent() {
  const { getToolRegistrationApiListTools } = useRestClient()
  const { data: tools } = getToolRegistrationApiListTools.useSuspenseQuery(undefined)
  const moduleFilterOptions = useMemo(() => getAgentToolsModuleFilterOptions(tools), [tools])

  return (
    <>
      <TablePageContainer>
        <DataTable
          title="Manage Agent Tools"
          columns={toolColumns}
          data={tools}
          filters={(table) => (
            <PlatformAgentToolsFilters table={table} moduleOptions={moduleFilterOptions} />
          )}
          action={
            <ToolForm
              sheetTitle="Add Tool"
              sheetDescription="Add a new tool"
              sheetTrigger={
                <Button size="sm" variant="outline">
                  <IconPlusOutline className="mr-2" />
                  Add tool
                </Button>
              }
            />
          }
        />
      </TablePageContainer>
    </>
  )
}
